module.exports = __webpack_public_path__ + "assets/icon_file_maintenance.9064f0fb.svg";